import React from 'react';
import Grid from '@material-ui/core/Grid';
import { Typography } from '@material-ui/core';
import env from 'consts/env';
import Dashboard from 'components/Layout/Dashboard/Dashboard';
import Icons from 'components/Icons';
import Router, { RouterTypes } from 'components/Router/Router';
import { Button } from 'components/Base';

const { withRouter } = Router;

interface Props extends RouterTypes {
  children: any;
}

class ErrorPage extends React.Component<Props> {
  state = {
    hasError: false
  };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  render() {
    const { hasError } = this.state;
    const {
      children,
      location: { pathname }
    } = this.props;

    const details = `
      INFO:%0D%0A
      - url: ${pathname}%0D%0A
      - env: ${env.BUILD_ENV}%0D%0A
    `;

    if (hasError) {
      return (
        <Dashboard>
          <Grid
            container
            direction="column"
            alignItems="center"
            style={{ height: '100vh' }}
          >
            <div style={{ margin: '5rem 0 1rem' }}>
              <Icons.Logo />
            </div>
            <Typography variant="h5">
              Oops, there seems to have been an error.
            </Typography>
            <Typography variant="h5">
              If this error persists or you need any further help don't hesitate
              to email
            </Typography>
            <Typography style={{ color: 'blue' }} variant="h5">
              <a href={`mailto:  support@fintegrate.co.uk?body=${details} `}>
                support@fintegrate.co.uk
              </a>
            </Typography>
            <a href="/" style={{ textDecoration: 'none' }}>
              <Button style={{ marginTop: '1rem' }}>Back to Dashboard</Button>
            </a>
          </Grid>
        </Dashboard>
      );
    }
    return children;
  }
}

export default withRouter(ErrorPage);
